import { createContext, ReactNode, useEffect, useState } from 'react';

const initialSettings = {
    showDescription: false,
    description: '',
    smallImage: '',
    mediumImage: '',
    largeImage: '',
    showAcknowledgments: false,
    acknowledgements: [] as string[],
    hideAfterRegistrationClose: false,
    bannerImage: '',
    backgroundColor: '',
    textColor: '',
};

type SettingsContextType = {
    settings: typeof initialSettings;
    loading: boolean;
    saveSettings: (data: any) => void;
};

export const SettingsContext = createContext<SettingsContextType>({
    settings: initialSettings,
    loading: true,
    saveSettings: () => {}
});

type SettingsProviderProps = {
    children: ReactNode;
}

export function SettingsProvider({ children }: SettingsProviderProps) {
    const [settings, setSettings] = useState<typeof initialSettings>(initialSettings);
    const [loading, setLoading] = useState(true);

    const saveSettings = (newSettings: any) => {
        const easyRegistration = newSettings.find((setting: any) => setting.type === 1);
        const description = newSettings.find((setting: any) => setting.type === 2);
        const smallImage = newSettings.find((setting: any) => setting.type === 4);
        const mediumImage = newSettings.find((setting: any) => setting.type === 5);
        const largeImage = newSettings.find((setting: any) => setting.type === 6);
        const acknowledgements = newSettings.find((setting: any) => setting.type === 8);
        const hideAfterRegistrationClose = newSettings.find((setting: any) => setting.type === 7);
        const bannerImage = newSettings.find((setting: any) => setting.type === 9);
        const backgroundColor = newSettings.find((setting: any) => setting.type === 10);
        const textColor = newSettings.find((setting: any) => setting.type === 11);

        setSettings((prevSettings) => ({
            ...prevSettings,
            ...{
                easyRegistration: easyRegistration?.status === 1,
                showDescription: description?.status === 1,
                description: description?.status === 1 ? description?.data : '',
                smallImage: smallImage?.status === 1 ? smallImage?.data : '',
                mediumImage: mediumImage?.status === 1 ? mediumImage?.data : '',
                largeImage: largeImage?.status === 1 ? largeImage?.data : '',
                showAcknowledgments: acknowledgements?.status === 1,
                acknowledgements: acknowledgements?.status === 1 ? JSON.parse(acknowledgements.data) : '',
                hideAfterRegistrationClose: hideAfterRegistrationClose?.status === 1,
                bannerImage: bannerImage?.status === 1 ? bannerImage.data : '',
                backgroundColor: backgroundColor?.status === 1 ? backgroundColor.data : '#29AAE1',
                textColor: textColor?.status === 1 ? textColor.data : '#FFFFFF',
            },
        }));
        setLoading(false);
    };

    useEffect(() => {
        document.documentElement.style.setProperty('--background-color', settings.backgroundColor || '#29AAE1');
        document.documentElement.style.setProperty('--text-color', settings.textColor || '#FFFFFF');
    }, [settings.backgroundColor, settings.textColor]);

    return (
        <SettingsContext.Provider value={{ settings, loading, saveSettings }}>{children}</SettingsContext.Provider>
    );
}
